import React from 'react';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListSubheader from '@material-ui/core/ListSubheader';
import Checkbox from '@material-ui/core/Checkbox';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  primary: { fontSize: '14px', lineHeight: '20px', marginLeft: '8px' },
  root: { paddingTop: '4px', paddingBottom: '4px' },
  subheader: {
    fontSize: '16px',
    color: 'rgba(0, 0, 0, 0.87)',
    fontWeight: 'bold',
    paddingLeft: '8px'
  },
  checkbox: {
    padding: '1px',
    // marginLeft: '8px'
  }
}));

const MultiselectList = (props) => {
  const { schema, specifiers } = props;
  const classes = useStyles();

  const getValues = (q) => {
    const values = Array.isArray(props.values?.specifiers?.[schema.name])
      ? [...props.values.specifiers[schema.name]]
      : [];

    if (values.includes(q)) {
      values.splice(values.indexOf(q), 1);
    } else {
      values.push(q);
    }

    return values;
  }

  const isChecked = (q) => {
    const values = Array.isArray(props.values?.specifiers?.[schema.name])
      ? [...props.values.specifiers[schema.name]]
      : [];
    return values.includes(q);
  }

  return (
    <List
      component="nav"
      aria-label="secondary mailbox folder"
      subheader={
        <ListSubheader 
          disableSticky={true} 
          classes={{ root: classes.subheader }} 
          component="div" 
          id="nested-list-subheader"
        >
          {schema.label}
        </ListSubheader>
      }
    >
      {
        specifiers[schema.name]
          .map(q => {
            const labelId = `checkbox-list-label-${q}`;
            return (
            <ListItem
              button
                classes={{ root: classes.root }}
                selected={props.values.specifiers?.[schema.name] === q}
                key={q}
                onClick={() => {
                  let values = getValues(q);

                  props.handleChange({
                    target: {
                      name: 'specifiers', value: {
                        ...props.values.specifiers,
                        [schema.name]: values
                      }
                    }
                  });
                  props.submitForm();
                }}
              >
                <Checkbox
                  edge="start"
                  checked={isChecked(q)}
                  tabIndex={-1}
                  classes={{ root: classes.checkbox }}
                  disableRipple
                  inputProps={{ 'aria-labelledby': labelId }}
                />
              <ListItemText classes={{ primary: classes.primary }} primary={q} />
            </ListItem>
          )})
      }
    </List>
  );
};

export default MultiselectList;